import { render, staticRenderFns } from "./ThumbBase.vue?vue&type=template&id=51b7c27e&scoped=true&"
import script from "./ThumbBase.vue?vue&type=script&lang=js&"
export * from "./ThumbBase.vue?vue&type=script&lang=js&"
import style0 from "./ThumbBase.vue?vue&type=style&index=0&id=51b7c27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b7c27e",
  null
  
)

export default component.exports